module.exports = function getResource(label, vars = []) {
    let resources = {
        orderText: 'Order',
        dateLocationText: 'Date & Location'
    };

    return resources[label];
};
